<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .avatar-group {
    display: flex;
    align-items: center;

    .avatar-wrapper {
      width: utils.in_rem(34px);
      height: utils.in_rem(34px);
      border: 2px solid white;
      border-radius: 50%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      &:not(:first-child) {
        margin-left: utils.in_rem(-12px);
      }
    }
  }
</style>

<script>
  import Avatar from "@sourcewhale/shared/svelte-design-system/components/atoms/Avatar.svelte";
  import cs1 from "../../modals/UpgradeModal/Images/cs1.png";
  import cs2 from "../../modals/UpgradeModal/Images/cs2.png";
  import cs3 from "../../modals/UpgradeModal/Images/cs3.png";
</script>

<div class="avatar-group">
  <div class="avatar-wrapper">
    <Avatar src={cs3} />
  </div>
  <div class="avatar-wrapper">
    <Avatar src={cs1} />
  </div>
  <div class="avatar-wrapper">
    <Avatar src={cs2} />
  </div>
</div>
